import React, { useMemo } from 'react';
import Table from './Table';
import { PaymentRequestsList } from '../../mockData';

const PaymentRequestsTable = () => {
  const tableHeader = useMemo(
    () => [
      {
        title: 'Talents',
        key: 'talent',
      },
      {
        title: "Talent's Id",
        key: 'id',
      },
      {
        title: 'Account',
        key: 'account',
      },
      {
        title: 'Date',
        key: 'date',
      },
      {
        /* dollars, supplied with the symbol in the header — so this keeps the
           symbol and only gains tabular alignment, per the money rule. */
        title: 'Amount ($)',
        key: 'amount',
        numeric: true,
      },
      {
        title: '',
        key: 'details',
      },
    ],
    []
  );

  return (
    <div>
      <Table header={tableHeader} label='' column={PaymentRequestsList} />
    </div>
  );
};

export default PaymentRequestsTable;
